/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  ForbiddenResponse,
  GetMBDiscrepancyTotalsResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get current total discrepancy for a monthly balance
 */
export const getMbDiscrepancyTotal = (signal?: AbortSignal) => {
  return customInstance<GetMBDiscrepancyTotalsResponse>({
    url: `/bm-declaration-service/v1/discrepancy/mb/total`,
    method: 'get',
    signal,
  });
};

export const getGetMbDiscrepancyTotalQueryKey = () => {
  return [`/bm-declaration-service/v1/discrepancy/mb/total`] as const;
};

export const getGetMbDiscrepancyTotalQueryOptions = <
  TData = Awaited<ReturnType<typeof getMbDiscrepancyTotal>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMbDiscrepancyTotal>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMbDiscrepancyTotalQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMbDiscrepancyTotal>>> = ({ signal }) =>
    getMbDiscrepancyTotal(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMbDiscrepancyTotal>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMbDiscrepancyTotalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMbDiscrepancyTotal>>
>;
export type GetMbDiscrepancyTotalQueryError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Get current total discrepancy for a monthly balance
 */
export const useGetMbDiscrepancyTotal = <
  TData = Awaited<ReturnType<typeof getMbDiscrepancyTotal>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMbDiscrepancyTotal>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetMbDiscrepancyTotalQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
